import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { api } from '../api-client.config';
import { Code } from './getCodes';

const updateCode = async (code: Code) => api.put(`/codes/${code.id}`, code);

export const useUpdateCodeMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['update-code'],
    mutationFn: updateCode,
    onSuccess: () => {
      toast.success('Code updated successfully');

      queryClient.invalidateQueries({
        queryKey: ['codes'],
      });
    },
    onError: (error) => {
      Promise.reject(error);
    },
  });
};
